export const TAB_IDS = {
  InterviewDetails: 'interview-details',
  PreparationCall: 'preparation-call',
  DebriefingCall: 'debriefing-call'
};

export const TAB_FOOTER_MODE = {
  [TAB_IDS.InterviewDetails]: 'close',
  [TAB_IDS.PreparationCall]: 'close-update',
  [TAB_IDS.DebriefingCall]: 'close-update'
};
